import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0c67d91e")

_pushScopeId("data-v-0c67d91e")
const _hoisted_1 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("textarea", {
      class: [[
        _ctx.disabled ? 'disabled-textarea' : '',
        _ctx.firstEnter && (_ctx.errorMessage || _ctx.errorServer.length) ? 'error-input' : '',
      ], "w-full input-area"],
      id: "w3review",
      name: "w3review",
      rows: "4",
      cols: "50",
      placeholder: _ctx.placeholder,
      disable: _ctx.disabled,
      value: _ctx.modelValue,
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChangeInput && _ctx.onChangeInput(...args)))
    }, null, 42, ["placeholder", "disable", "value"]),
    ((_ctx.validated || _ctx.firstEnter) && (_ctx.errorMessage || _ctx.errorServer.length))
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_ErrorMessage, {
            "error-server": _ctx.errorServer,
            "error-message": _ctx.errorMessage
          }, null, 8, ["error-server", "error-message"])
        ]))
      : _createCommentVNode("", true)
  ]))
})